<div class="qa-question" [class.qa-page-break-card]="!classicLayout" [class.qa-classic]="classicLayout" [class.expanded]="classicLayout"
     [class.qa-selected]="selected && !classicLayout" id="{{question.id}}" #qaQuestion (click)="classicLayout || selectQuestion()">
  <!-- classic layout: the page break card of the old editor around the shared property template -->
  <ng-container *ngIf="classicLayout; else modernCard">
    <div class="qa-question-bar">
      <div class="btn-group">
        <button type="button" class="btn btn-success qa-position">{{position + 1}}</button>
        <button type="button" class="btn btn-primary qa-question-type"><i class="fa fa-file-text-o"></i> {{_(KEYS.EDITOR.PAGE_BREAK)}}</button>
      </div>
    </div>
    <div class="qa-question-buttons">
      <button type="button" class="btn btn-danger" (click)="onDelete()" [disabled]="pageViewEnabled"><i class="fa fa-trash"></i></button>
    </div>
    <div class="qa-question-hr"></div>
    <div class="qa-question-handle">
      <div class="btn-group-vertical">
        <button type="button" class="btn btn-primary" [class.qa-handle-control]="!pageViewEnabled" [disabled]="pageViewEnabled">
          <i class="fa fa-arrows" [class.qa-handle-control]="!pageViewEnabled"></i>
        </button>
      </div>
    </div>
    <div class="qa-classic-body">
      <ng-container *ngTemplateOutlet="properties"></ng-container>
    </div>
  </ng-container>
  <ng-template #modernCard>
  <div class="qa-preview-topline">
    <span class="qa-preview-number">{{position + 1}}</span>
    <button type="button" class="qa-card-tool qa-handle-control" [disabled]="pageViewEnabled"
            [ngbTooltip]="_(KEYS.EDITOR.DRAG_ELEMENT)" [attr.aria-label]="_(KEYS.EDITOR.DRAG_ELEMENT)">
      <i class="fa fa-arrows qa-handle-control" aria-hidden="true"></i>
    </button>
    <span class="qa-preview-type">
      <i class="fa fa-file-text-o" aria-hidden="true"></i> {{_(KEYS.EDITOR.PAGE_BREAK)}}</span>
    <button class="qa-card-select" (click)="selectQuestion(); $event.stopPropagation()"
            [attr.aria-pressed]="selected" [attr.aria-label]="_(KEYS.EDITOR.EDIT) + ': ' + (position + 1)">
      <i class="fa fa-sliders" aria-hidden="true"></i> {{_(KEYS.EDITOR.PROPERTIES)}}
    </button>
  </div>
  <div class="qa-page-break-title qa-preview-editable" *ngIf="question.title[locale]" role="button" tabindex="0"
       [attr.aria-label]="_(KEYS.EDITOR.EDIT) + ': ' + _(KEYS.EDITOR.TITLE)"
       (click)="focusProperty('title', $event)" (keydown.enter)="focusProperty('title', $event)"
       (keydown.space)="focusProperty('title', $event)">{{question.title[locale]}}</div>
  </ng-template>
</div>
<ng-template #properties>
  <div class="qa-properties-content" (input)="markPreviewForCheck()" (change)="markPreviewForCheck()" (click)="markPreviewForCheck()">
    <div class="qa-properties-heading" *ngIf="!classicLayout"><span>{{position + 1}} · {{_(KEYS.EDITOR.PAGE_BREAK)}}</span>
      <button class="btn btn-sm btn-danger" (click)="onDelete()" [disabled]="pageViewEnabled" [attr.aria-label]="_(KEYS.EDITOR.REMOVE)"><i class="fa fa-trash"></i></button>
    </div>
    <label class="qa-property-label" *ngIf="!classicLayout" [for]="'page-break-title-' + question.id">{{_(KEYS.EDITOR.TITLE)}}</label>
    <input #plainTitleEditor [id]="'page-break-title-' + question.id" class="form-control" placeholder="{{_(KEYS.EDITOR.ENTER_TITLE)}}"
           [(ngModel)]="question.title[locale]" (ngModelChange)="onTitleChange()">
  </div>
</ng-template>
